import { useMutation, UseMutationResult } from '@tanstack/react-query'

import { brand } from '@/utils/brand'

export interface GoogleTokenExchangePayload {
  access_token: string
  frontend_app: boolean
}

export interface GoogleTokenExchangeResponse {
  account_exists: boolean
  auth_token?: string
  complete?: boolean
  user_id: string
  user_country_code?: string | null
  user_email?: string | null
  user_first_name?: string | null
  user_last_name?: string | null
  user_phone_number?: string | null
}

const exchangeGoogleToken =
  (authBackend: string) =>
  async (payload: GoogleTokenExchangePayload): Promise<GoogleTokenExchangeResponse> => {
    const response = await fetch(`${authBackend}/auth/google/credentials/callback`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    })

    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(errorData.message || 'Failed to post googleAuth')
    }

    return response.json()
  }

const useExchangeGoogleToken = (): UseMutationResult<
  GoogleTokenExchangeResponse,
  Error,
  GoogleTokenExchangePayload,
  unknown
> => {
  const authBackend = process.env.NEXT_PUBLIC_AUTH_BACKEND || `https://www.staging.${brand.key}.com`

  return useMutation<GoogleTokenExchangeResponse, Error, GoogleTokenExchangePayload>({
    mutationFn: exchangeGoogleToken(authBackend),
  })
}

export default useExchangeGoogleToken
